import React from 'react';
import {Container}  from 'react-bootstrap';

const Border = () =>{
  return (
    <Container className='d-flex justify-content-center aligns-items-center mt-5 mb-5 w-100' fluid>
        <span className='borderSpan'></span>
    </Container>
  );
};

export default Border;
